import { createFileRoute } from '@tanstack/react-router';
import { LegalPage } from '#/components/LegalPage';
import { privacySections } from '#/lib/legal';
import { pageTitle } from '#/lib/site';
import { getSpace } from '#/lib/space-fn';

export const Route = createFileRoute('/privacy-policy')({
  head: ({ loaderData }) => ({
    meta: [{ title: pageTitle('Privacy Policy', loaderData?.space) }],
  }),
  loader: async () => {
    const space = await getSpace();
    return { space };
  },
  component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
  const { space } = Route.useLoaderData();

  if (!space) return null;

  return (
    <LegalPage
      space={space}
      title="Privacy Policy"
      lastUpdated="Laatst bijgewerkt: 18 september 2026"
      sections={privacySections(space)}
    />
  );
}
